module.exports = new __parcel__URL__("b2b-icon-sonstiges.4ed781cf.png").toString();